import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { prescriptionQKeys } from "@hooks/queries/prescription/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useCreatePrescription = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (prescription: FormData) => {
      return api.post("prescription/", prescription, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      // console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "create-prescription-success",
      });
      queryClient.invalidateQueries({
        queryKey: prescriptionQKeys.patient(
          variables.get("patient_id") as string
        ),
      });
      queryClient.invalidateQueries({
        queryKey: prescriptionQKeys.consultation(
          variables.get("consultation_id") as string
        ),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.get("patient_id") as string),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Prescription]", res);
      handleErrors(res, "mutation");
    },
  });
};
